// extracted by mini-css-extract-plugin
export default {"grid-list":"GridList_grid-list__TcWux","grid-list-header":"GridList_grid-list-header__yliGs"};